<template>
  <div :class="classes">
    <pt-page-title title="生命体验馆列表">
      <template slot="before-left">
        <el-button type="primary" @click="createCompany">新建生命体验馆</el-button>
      </template>
    </pt-page-title>
    <pt-life-experience-pavilion-table :tableLabels="tableLabels" ref="table" :class="$style['pt-hospital-table']">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="iconfont icon-bianji" @click="goEdit(scope.row)"></i>
          <i class="iconfont icon-shanchu" @click="goDelete(scope.row)"></i>
          <a id="btnDownload" :class="$style['download-qrcode']" @click="downLoad(scope.row)">下载二维码</a>
        </template>
      </el-table-column>
    </pt-life-experience-pavilion-table>
  </div>
</template>

<script>
import {
  lifeExperiencePavilionTableLabels
} from './life-experience-pavilion'
import ptLifeExperiencePavilionTable from './pt-life-experience-pavilion-table/withData'
const prefixCls = 'pt-life-experience-pavilion'

export default {
  name: 'pt-life-experience-pavilion',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptLifeExperiencePavilionTable
  },
  data () {
    return {
      tableLabels: lifeExperiencePavilionTableLabels
    }
  },
  methods: {
    getTableData () {
      this.$refs.table.getTableData()
    },
    goEdit (val) {
      this.$router.push('/life-experience-pavilion-form/true/' + val.id)
    },
    createCompany (val) {
      this.$router.push('/life-experience-pavilion-form/false/0')
    },
    goDelete (val) {
      this.$confirm('您确定删除该生命体验馆吗？', '删除生命体验馆', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$emit('deleteLifeExperienceHallsList', val.id)
      })
    },
    goDetail (val) {
      this.$router.push('./life-experience-pavilion-detail/' + val.id)
    },
    downLoad (val) {
      this.$store.dispatch('downloadLifeExperienceHallsQrcode', val.id).then(res => {
        this.downloadFile(val.name + '二维码', res)
      }).catch(err => {
        this.$message.error(err || '下载生命体验馆二维码失败')
      })
    },
    downloadFile (fileName, content) {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(content) // new Blob([content]);
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName
      aLink.href = URL.createObjectURL(blob)
      aLink.click()
    },
    base64ToBlob (code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-hospital-table {
    :global .iconfont {
      margin-right: 10px;
    }
  }
  .download-qrcode{
    color:#edbe81
  }
</style>
